module.exports = __webpack_public_path__ + "img/toggle-light-01.093e0502.png";